<template>
  <h2 class="text-surface-700 mt-12 flex items-center gap-3 text-xl font-semibold">
    <slot />
  </h2>
</template>
